/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Button } from '@material-ui/core';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import { useSelector } from 'react-redux';

import { ChallengeResultType } from 'interfaces';
import { Title } from 'components';
import UsersPhoto, {
  PhotoStatusType,
} from 'components/widgets/WidgetAction/Results/PhotoResult/UsersPhoto';
import { useImgSrc } from 'core/utils/use-img-src.hook';
import { userInfosSelector } from 'reducers/app.reducer';
import Voting from '../Voting';
import { cssContainer, cssName, cssPhotodetail, cssZoomButton } from './styles';
import { useTranslation } from 'react-i18next';
import { challengeSelector } from 'reducers/challenge.reducer';
import { useParams } from 'react-router-dom';

const PhotoBlock: React.FC<{
  onImageClick: () => void;
  result: ChallengeResultType;
  withVotingButton: boolean;
  getChallengeResultsByUser: () => void;
}> = ({
  onImageClick,
  result,
  withVotingButton,
  getChallengeResultsByUser,
}) => {
  const { t } = useTranslation();
  const { src } = useImgSrc(result?.image?.id);
  const { id: challengeId }: { id: string } = useParams();
  const { data: challengeData } = useSelector(
    challengeSelector(Number(challengeId)),
  );
  const areResultsAnonymized = challengeData.areResultsAnonymized;

  const { id: userId } = useSelector(userInfosSelector);
  const isMe = result.entity['@id'] === `/v2/users/${userId}`;
  const hasMyVote = result.voters
    ?.map((voter) => voter['@id'])
    .includes(`/v2/users/${userId}`);
  let status: PhotoStatusType = 'default';
  if (hasMyVote) {
    status = 'primary';
  }
  if (isMe) {
    status = 'secondary';
  }

  return (
    <div css={cssContainer} id={isMe ? 'me' : ''}>
      <div>
        <UsersPhoto
          imageUrl={src}
          challengeResults={result}
          withRank
          size="large"
          status={status}
        />
      </div>
      <div css={cssPhotodetail}>
        <Button variant="contained" css={cssZoomButton} onClick={onImageClick}>
          <ZoomInIcon fontSize="inherit" />
        </Button>
        {areResultsAnonymized && !isMe ? (
          <Title
            weight="normal"
            size="h4"
            position="center"
            css={cssName}
            isParagraph
          >
            {t('challenges.participant')}
          </Title>
        ) : (
          <Title
            weight="normal"
            size="h4"
            position="center"
            css={cssName}
            isParagraph
          >
            {result.entity?.profile?.firstName}{' '}
            <strong>{result.entity?.profile?.lastName}</strong>
          </Title>
        )}
        <Voting
          result={result}
          isMe={isMe}
          hasMyVote={hasMyVote}
          withVotingButton={withVotingButton}
          getChallengeResultsByUser={getChallengeResultsByUser}
        />
      </div>
    </div>
  );
};

export default PhotoBlock;
